import { MessageBar, MessageBarType, Spinner } from 'office-ui-fabric-react';
import React, { Component } from 'react';
import { Query } from 'react-apollo';
import { MyContext } from '../../../../context';
import * as QueryPatterns from '../PatternsQuery';
import EditPattern from './EditPattern';

class EditPatternContainer extends Component {
    static contextType = MyContext

    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        const { auth, apol, hidePanel } = this.props
        const id = this.props.patternId
        return (
            <div>
                {/*Edit pattern*/}
                {id !== null && (
                    <Query
                        query={QueryPatterns.queryGetPattern}
                        variables={{ auth, id }}>
                        {({ loading, error, data }) => {
                            if (loading) {
                                return (
                                    <Spinner label={this.context.getTranslation("common", "loading")} ariaLive="assertive" labelPosition="top" />
                                )
                            }
                            if (error) {
                                return (
                                    <MessageBar
                                        messageBarType={MessageBarType.error}
                                        isMultiline={false}
                                        dismissButtonAriaLabel="Close"
                                    >
                                        {this.context.getTranslation("compliance", "error")}
                                    </MessageBar>
                                )
                            }
                            if (data.getPatternDetection == null) {
                                return (<MessageBar>
                                    {this.context.getTranslation("compliance", "noData")}
                                </MessageBar>)
                            }
                            return (<div>
                                <EditPattern
                                    data={data.getPatternDetection}
                                    closePanel={hidePanel}
                                    apol={apol}
                                    auth={auth}
                                    userRules={this.props.userRules}
                                    refreshPatterns={this.props.refreshPatterns}
                                    setMessageError={this.props.setMessageError}
                                />
                            </div>
                            )
                        }}
                    </Query>
                )
                }
                {/*Create patter*/}
                {
                    id === null && (
                        <div>
                            <EditPattern
                                closePanel={hidePanel}
                                apol={apol}
                                auth={auth}
                                userRules={this.props.userRules}
                                withFragments={this.props.withFragments}
                                refreshPatterns={this.props.refreshPatterns}
                                setMessageError={this.props.setMessageError}
                            />
                        </div>
                    )
                }
            </div>
        );
    }
}

export default EditPatternContainer;